export default "__VITE_ASSET__Diu1qDN0__"